import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { FilterGlobalResponseModel } from 'src/app/models/responses/filter-global-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';
import { NoteDetailModel } from './../../models/invoicing/note-detail.model';

@Injectable({
  providedIn: 'root'
})
export class NoteDetailService {

  constructor(private _httpClient: HttpClient) { }
  getArticlesForNote(noteId: number, conceptInvoicingId: number, storeId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('noteId', noteId)
      .set('conceptInvoicingId', conceptInvoicingId)
      .set('storeId', storeId)
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteDetail.GetArticlesForNote}`,
      filters, { params: params }
    );
  }

  getNoteDetailById(noteDetailId: number): Observable<NoteDetailModel> {
    return this._httpClient.get<NoteDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteDetail.GetNoteDetailById}/${noteDetailId}`);
  }

  createNoteDetail(noteDetailContract: NoteDetailModel): Observable<NoteDetailModel> {
    return this._httpClient.post<NoteDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteDetail.CreateNoteDetail}`,
      noteDetailContract);
  }

  updateNoteDetail(noteContract: NoteDetailModel): Observable<NoteDetailModel> {
    return this._httpClient.put<NoteDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteDetail.UpdateNoteDetail}`,
      noteContract);
  }

  deleteNoteDetail(noteDetailIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteDetail.DeleteNoteDetail}`,
      noteDetailIds);
  }

  getNoteDetailsByNoteId(noteId: number): Observable<Array<NoteDetailModel>> {
    return this._httpClient.get<Array<NoteDetailModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteDetail.GetNoteDetailsByNoteId}/${noteId}`)
  }

  getNoteDetailByKeys(noteId: number, conceptInvoicingId: number, storeId: number, articleId: number | null): Observable<NoteDetailModel> {
    let params = new HttpParams()
    params = params.set('noteId', noteId)
    params = params.set('conceptInvoicingId', conceptInvoicingId)
    params = params.set('storeId', storeId)
    if (articleId !== null) params = params.set('articleId', articleId.toString());
    return this._httpClient.get<NoteDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteDetail.GetNoteDetailByKeys}`, { params: params });
  }

  GetColumnsForArticleCaptureNote(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteDetail.GetColumnsForArticleCaptureNote}`);
  }

  getColumnsForDetailConsultation(isDocumentSupport: boolean): Observable<FilterGlobalResponseModel> {
    let params = new HttpParams()
    params = params.set('isDocumentSupport', isDocumentSupport)
    return this._httpClient.get<FilterGlobalResponseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteDetail.GetColumnsForDetailConsultation}`,
      { params: params });
  }

  getAllNoteDetailsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[], isDocumentSupport: boolean): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant)
      .set('isDocumentSupport', isDocumentSupport);

    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteDetail.GetAllNoteDetailsWithPagination}`,
      filters, { params: params }
    );
  }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean, isDocumentSupport: boolean): Observable<Blob> {
    const params = new HttpParams()
      .set('columnSort', columnSort ?? '')
      .set('ascendant', ascendant.toString())
      .set('isDocumentSupport', isDocumentSupport);

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteDetail.ExportDetailConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getColumnsForDetailsNote(isDocumentSupport: boolean): Observable<ColumnResponseModel[]> {
    let params = new HttpParams()
    params = params.set('isDocumentSupport', isDocumentSupport)
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteDetail.GetColumnsForDetailsNoteAsync}`,
      { params: params });
  }

  getNotesDetailsByNoteIdWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, noteId: number,
    isDocumentSupport: boolean): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant)
      .set('noteId', noteId)
      .set('isDocumentSupport', isDocumentSupport);

    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteDetail.GetNotesDetailsByNoteIdWithPagination}`,
      { params }
    );
  }

  getAllConceptInvoicingForSelectAsync(invoiceId: number): Observable<Array<any>> {
    let params = new HttpParams()
    params = params.set('invoiceId', invoiceId)
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteDetail.GetAllConceptInvoicingForSelectAsync}`,
      { params: params }
    );
  }

  getArticleById(articleId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteDetail.GetArticleByIdAsync}/${articleId}`);
  }

  getAllStoreForSelectAsync(invoiceId: number, conceptInvoicingId: number): Observable<Array<any>> {
    let params = new HttpParams()
    params = params.set('invoiceId', invoiceId)
    params = params.set('conceptInvoicingId', conceptInvoicingId)
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.noteDetail.GetAllStoreForSelectAsync}`,
      { params: params }
    );
  }
}
